import { Injectable } from '@angular/core';

/**
 * Almacén de la sesión de portal (payload elegido en select-portal /
 * impersonación admin). Vive en sessionStorage: scope por pestaña, muere al
 * cerrarla. La AUTORIZACIÓN admin nunca sale de aquí: se deriva del JWT
 * (SecurityService.isSuperAdmin()); este servicio solo guarda datos.
 */
@Injectable({ providedIn: 'root' })
export class SessionStoreService {
  private readonly key = 'sesion';
  private readonly portalsKey = 'allSessions';
  private readonly activePortalKey = 'activePortalId';

  setSesion(payload: any): void {
    sessionStorage.setItem(this.key, JSON.stringify(payload));
    localStorage.removeItem(this.key);
  }

  getSesion(): any | null {
    const raw = this.getWithLegacyMigration(this.key);

    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      sessionStorage.removeItem(this.key);
      return null;
    }
  }

  setActivePortalId(id: string): void {
    sessionStorage.setItem(this.activePortalKey, id);
    localStorage.removeItem(this.activePortalKey);
  }

  getActivePortalId(): string {
    return this.getWithLegacyMigration(this.activePortalKey) || '';
  }

  private getWithLegacyMigration(key: string): string | null {
    const current = sessionStorage.getItem(key);
    if (current !== null) return current;

    const legacy = localStorage.getItem(key);
    if (legacy !== null) {
      sessionStorage.setItem(key, legacy);
      localStorage.removeItem(key);
    }
    return legacy;
  }

  clear(): void {
    [this.key, this.portalsKey, this.activePortalKey].forEach(key => {
      sessionStorage.removeItem(key);
      localStorage.removeItem(key);
    });
  }
}
